import { API_URL } from '../config';
import { makeApiCall } from '../_common/api.utils';

export const createVisitorPassData = async (data: string) => {
	try {
		const URL = `${API_URL}CreateVisitorPass`;
		console.log('Create Visitor Pass API URL:', URL);
		console.log('Request data (encrypted string):', data);
		const requestData = {
			createVisitorPassToken: data,
		};
		return makeApiCall(URL, requestData);
	} catch (error) {
		console.error('Error in createVisitorPass Data:', error);
		throw error;
	}
};

export const getAllVisitorPassesData = async (data: any) => {
	try {
		const URL = `${API_URL}GetAllVisitorPasses`;
		console.log('Get All Visitor Passes API URL:', URL);
		console.log('Request params:', data);
		const requestData = {
			getAllVisitorPassesToken: data,
		};
		return makeApiCall(URL, requestData);
	} catch (error) {
		console.error('Error in getAllVisitorPassesData:', error);
		throw error;
	}
};

export const getVisitorPassData = async (data: any) => {
	try {
		const URL = `${API_URL}GetVisitorPass`;
		console.log('Get Visitor Pass API URL:', URL);
		console.log('Request params:', data);
		const requestData = {
			getVisitorPassToken: data,
		};
		return makeApiCall(URL, requestData);
	} catch (error) {
		console.error('Error in getVisitorPassData:', error);
		throw error;
	}
};

export const updateVisitorPassData = async (data: string) => {
	const URL = `${API_URL}UpdateVisitorPass`;
	console.log('Update Visitor Pass API URL:', URL);
	console.log('Request data (encrypted string):', data);
	const requestData = {
		updateVisitorPassToken: data,
	};
	return makeApiCall(URL, requestData);
};

export const deleteVisitorPassData = async (data: any) => {
	try {
		const URL = `${API_URL}DeleteVisitorPass`;
		console.log('Delete Visitor Pass API URL:', URL);
		console.log('Request params:', data);
		const requestData = {
			deleteVisitorPassToken: data,
		};
		return makeApiCall(URL, requestData);
	} catch (error) {
		console.error('Error in deleteVisitorPassData:', error);
		throw error;
	}
};
